// extracted by mini-css-extract-plugin
export default {"buttonDescription":"buttonDescription__Xd4S+"};